var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentBuilds(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_3530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4444 5.09305C12.3397 5.88231 12.8847 6.99487 12.9597 8.18599C13.0346 9.37711 12.6333 10.5492 11.844 11.4445C11.0085 12.385 9.84181 12.9661 8.58777 13.0663L6.99286 13.1667",
    stroke: "#057DCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86815 14.8199L6.99287 13.1667L8.64615 11.2914",
    stroke: "#057DCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49265 11.844C4.59741 11.0548 4.05238 9.94221 3.97744 8.75109C3.9025 7.55997 4.3038 6.38786 5.09306 5.49263C5.92855 4.5521 7.0953 3.97097 8.34933 3.87075L9.94424 3.77041",
    stroke: "#057DCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29094 5.64568L9.94422 3.7704L8.06894 2.11712",
    stroke: "#057DCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_3530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(16.9371 7.93574) rotate(131.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentBuilds);
export default __webpack_public_path__ + "static/media/RecentBuilds.42d2b533fc0c79ff150cc3640e84dd41.svg";
export { ForwardRef as ReactComponent };